import * as t from 'io-ts'
export const IdC = t.type({id: t.string})
export const withId = <A extends t.Mixed>(a: A) => t.intersection([a, IdC])
export type WithId<T> = T & {id: string}
